import React, { Component } from 'react';

export default class CustomIcon extends Component<any, any> {
  render() {
    return (
      <span className={`icon-${this.props.name}`} style={this.props.style} />
    );
  }
}
